import angular from 'angular';
import iconList from './icons';

angular.module('folkeuni').filter('to_trusted', ['$sce', function($sce){
	return function(text) {
		return $sce.trustAsHtml(text);
	};
}]);

angular.module('folkeuni').component('icon', {
	bindings: {
		height: '@',
		width: '@',
		color: '@',
		icon: '@'
    },
	controller: function ($scope) {
		const $ctrl = this;
		$ctrl.Icon = "";

		$ctrl.$onInit = function () {
			$ctrl.Icon = iconList[$ctrl.icon] || null;
		}
	},
	transclude: true,
	templateUrl: '/shop-dist/templates/icon.html?c=' + window.cacheBurst,
});